import { useMemo } from 'react'

import { useBankLineSuggestionsMap } from '@features/reconciliation/hooks'
import { BookkeepingItem } from '@features/reconciliation/types/bookkeepingItem'
import { getSuggestionsByBankLineId } from '@features/reconciliation/utils'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { useSandboxModeContext } from '../contexts/sandboxModeContext'

interface UseSandboxBankLineSuggestionsMapProps {
  accountId?: string
  bankLines: BankLine[]
  bookkeepingItems?: BookkeepingItem[]
  enabled?: boolean
  organizationId?: string
}

export const useSandboxBankLineSuggestionsMap = ({
  accountId,
  bankLines,
  bookkeepingItems,
  enabled = true,
  organizationId,
}: UseSandboxBankLineSuggestionsMapProps) => {
  const sandbox = useSandboxModeContext()
  const result = useBankLineSuggestionsMap({
    accountId,
    bankLines,
    bookkeepingItems,
    enabled: !sandbox && enabled,
    organizationId,
  })
  const suggestionsByBankLineId = useMemo(
    () => getSuggestionsByBankLineId(sandbox?.sandboxState.suggestions ?? [], bookkeepingItems),
    [bookkeepingItems, sandbox],
  )

  return sandbox ? { suggestionsByBankLineId, isLoading: false } : result
}
